const EntityTypes = {
    Council: 1,
    Institution: 2,
    Secretary: 3,
    Benefactor: 4,
    Fund: 5
};

export default EntityTypes;